import { render, staticRenderFns } from "./yjzs.vue?vue&type=template&id=bcaacd38&scoped=true"
import script from "./yjzs.vue?vue&type=script&lang=js"
export * from "./yjzs.vue?vue&type=script&lang=js"
import style0 from "./yjzs.vue?vue&type=style&index=0&id=bcaacd38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcaacd38",
  null
  
)

export default component.exports